import { strategyToOptions } from '@/common/utils/strategyToOptions'

export const branchHierarchyForUserAccess = {
  same_and_descendents: 'Mesma filial e descendentes',
  all: 'Todas da empresa',
  dynamic: 'Dinâmico',
}

export const branchHierarchyForUserAccessOptions = strategyToOptions(branchHierarchyForUserAccess)
